import doc                            from '@widesk-core/decorators/doc';
import AbstractTimedNotificationModel from './AbstractTimedNotificationModel';
import { Translatable }               from '@widesk-core/decorators/translatable';
import { RenderNameProps }            from '@widesk-ui/mixins/ApiModelRenderName';

@doc.urnResource('timed_notification')
@doc.translatable({ title: true, text: true, url: true })
class TimedNotificationModel extends AbstractTimedNotificationModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & TimedNotificationNameProps) {
		return super.renderName(props);
	}
}

interface TimedNotificationModel
	extends Translatable<{ title: true, text: true, url: true }> {
}

export default TimedNotificationModel;
